import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { QueryKeys } from "constants/query-keys";
import { ApiManager } from "services/api";
import { IAccountIntroFlagsDataDto } from "services/api/knowledgebase/knowledgebase-api";
import { selectIsViewer } from "store/entities/agents";

const fetchKnowledgeBaseIntroFlags = async (): Promise<IAccountIntroFlagsDataDto> => {
  const { result, error } = await ApiManager.knowledgebaseApi.fetchIntroFlags();
  if (error) {
    throw error;
  }
  return result as IAccountIntroFlagsDataDto;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useKnowledgeBaseIntroFlags = () => {
  const isViewer = useSelector(selectIsViewer);

  const { data, isLoading } = useQuery<IAccountIntroFlagsDataDto>({
    queryKey: [QueryKeys.KnowledgeBaseIntroFlags],
    queryFn: fetchKnowledgeBaseIntroFlags,
    refetchOnWindowFocus: false,
    enabled: !isViewer,
  });

  return {
    introFlags: data?.data.adminApp,
    isLoading,
  };
};
